import { View } from "react-native";
import { useTranslation } from "react-i18next";
import { CatalogBrowse, painRiskLabel, resolveTheme } from "@jackedlogs/ui";
import type { PainMap } from "@jackedlogs/shared";
import { apiFetch } from "./api";
import { PainDot } from "./PainDotWeb";
import { displayUnitOf, useProfileDoc } from "./useProfileDoc";
import { useThemePalette } from "./theme";

// THE Catalog surface on web-rnw — the SAME shared list + detail views
// mobile's Settings → Catalog screens mount, composed by CatalogBrowse into
// a responsive master-detail (wide: list | detail; narrow: list → detail).
// Read-only browse; the admin CRUD editor stays on legacy apps/web (see
// next/rnw-strangler.md §8). Web seams: catalog via the shared
// useCatalogItems (no offline cache → network), Intl date formatting, and
// the athlete's own display unit (displayUnitOf — it used to be a hardcoded
// "kg" here, which showed an lb athlete numbers wrong by 2.2×). No native chrome — the Settings
// sub-nav supplies the back row. renderPainDot wired 2026-08-17
// (PainDotWeb.tsx) — painMap has been a web-rnw surface since the
// pain-map-picker lift, 2026-08-16.

const formatDate = (iso: string, locale: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
  }).format(d);
};

export function CatalogScreen() {
  const { dark, family } = useThemePalette();
  const theme = resolveTheme(dark, family);
  const { t } = useTranslation();
  const { doc } = useProfileDoc();
  const painMap = doc?.["painMap"] as PainMap | undefined;
  return (
    <View style={{ flex: 1, backgroundColor: theme.palette.bg }}>
      <CatalogBrowse
        theme={theme}
        apiFetch={apiFetch}
        unit={displayUnitOf(doc)}
        formatDate={formatDate}
        renderPainDot={(ex) => <PainDot exercise={ex} />}
        getPainRiskLabel={(ex) => painRiskLabel(ex, painMap, t)}
      />
    </View>
  );
}
